import { AppBar, Box, Breadcrumbs, makeStyles, Tabs, Tab, Theme, Typography, withStyles, createStyles, useTheme, useMediaQuery } from "@material-ui/core";
import { ANALYZE_TABBAR_TITLES } from "../../../../../../config/mock";
import UtilService from "../../../../../../helper/service";
import AnalysisScoreIcon from "../../../../../atoms/creator/analyzeScoreIcon";
import {useState} from "react";
import { useSelector } from 'react-redux';
import useWindowSize from "../../../../../../helper/hooks/useWindowSize";

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#fff',
    height: 100,
    paddingLeft: 80,
    marginTop: 66,
    '@media (max-width: 1320px)': {
      marginTop: 60,
    },
    '@media (max-width: 960px)': {
      marginTop: 60,
    },
  },
  breadcrumbs: {
    marginLeft: 20,
    marginTop: 10
  },
  breadcrumbtxt: {
    fontSize: 11,
    color: '#606B76',
    cursor: 'pointer',
    fontFamily: 'roboto-regular',
    textTransform: 'uppercase'
  },
  tooltipDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  statustitle: {
    fontFamily: 'Spartan-bold',
    fontSize: 25,
    color: '#1DB859',
    marginTop: 4
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  statustxt: {
    color: '#697683',
    fontSize: 20,
    fontFamily: 'Spartan-bold',
    paddingTop: theme.spacing(1),
    textTransform: 'capitalize',
    textAlign: 'right'
  },
  containerCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    fontSize: 30,
    fontFamily: 'Spartan-bold',
    color: '#000',
    marginLeft: 20,
    height: 60,
    marginTop: 10,
    '@media (max-width: 1024px)': {
      fontSize: 20,
    },
    '@media (max-width: 600px)': {
      // whiteSpace: 'nowrap',
      // width: 224,
      // // background:'brown',
      // height: 50,
      // overflow: 'hidden'
    },
  } 
}));

const Module4Slide2Header = () => {

  const classes = useStyles();
  const [tabBar, setTabBar] = useState('/analyze');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { width } = useWindowSize();

  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { module4Data } = userPreferences;
  const { session } = module4Data.value;

  const immersion = session.immersionIndex
  const safety = session.safetyIndex

  const handleChange = ({ }, newValue: string) => {
    setTabBar(newValue);
  };

  return (
    <AppBar className={classes.root}>
      <Box mr={3} className={classes.row} style={{ justifyContent: 'space-between' }}>
        <div style={{marginLeft: isMobile ? -80 : 0}}>
          <Breadcrumbs className={classes.breadcrumbs} separator={'>'} aria-label="breadcrumb">
            <Typography className={classes.breadcrumbtxt}>Home</Typography>
            {/* <Typography className={classes.breadcrumbtxt}>Harry potter ads</Typography> */}
          </Breadcrumbs>
          <div className={classes.title}>{session.session_title}</div>
        </div>

        <div>
          <Box className={classes.row}>
            <div className={classes.tooltipDiv}>
              <AnalysisScoreIcon color={immersion.color_indicator} type={'immersion'} size={1} />
              <Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor(immersion.color_indicator) }}>
                {immersion.immersion_index}
              </Box>
            </div>

            <Box ml={3} className={classes.tooltipDiv}>
              <AnalysisScoreIcon color={safety.safety_index > 1 ? safety.color_indicator : 'gray'} type={'safety'} size={1} />
              <Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor(safety.safety_index > 1 ? safety.color_indicator : 'gray') }}>
                {safety.safety_index > 1 ? safety.safety_index : '--'}
              </Box>
            </Box>
          </Box>

          <Box className={classes.statustxt}>
            Completed
          </Box>
        </div>

      </Box>

      { width > 600 && <AntTabs value={tabBar} onChange={handleChange} aria-label="participant manage tabs" style={{marginTop: -30}}>
        {ANALYZE_TABBAR_TITLES.map((t, i) =>
          <AntTab
            key={i}
            label={
              <div className={classes.containerCenter}>
                <div>{t.label}</div>
              </div>
            }
            href={t.path}
            value={t.path} {...a11yProps(i)}
            labelvalue={t.label}
          />
        )
        }
      </AntTabs>}

    </AppBar>
  )
};

export default Module4Slide2Header;

const AntTabs = withStyles((theme: Theme) => ({
  root: {
    margin: "0 auto",
    minHeight: 35,
    marginTop: theme.spacing(-2),
    paddingLeft: 65,
    '@media (max-width: 960px)': {
      paddingLeft: 0
    },
    '@media (max-width: 600px)': {
      marginTop: 0,
      paddingTop: 10,
      paddingBottom: 10
    },
  },
  indicator: {
    backgroundColor: '#1890ff',
    height: 3
  },
}))(Tabs);

const AntTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: 0,
      textTransform: 'none',
      minWidth: 72,
      fontWeight: 'lighter',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      minHeight: '35px',
      color: "#697683",
      fontFamily: [
        'roboto-regular',
      ].join(','),
      '@media screen and (min-width: 321px) and (max-width: 424px)': {
        minWidth: 55,
        marginLeft: 10,
        marginRight: 10
      },
      '@media screen and (max-width: 320px)': {
        minWidth: 55,
        marginLeft: 8,
        marginRight: 8
      },
      '&:hover': {
        color: '#40a9ff',
        opacity: 1,
      },
      '&$selected': {
        color: '#017AEF',
        fontWeight: 'normal',
        fontFamily: 'roboto-bold'
      },
      '&:focus': {
        color: '#017AEF',
      },
    },
    selected: {},
  }),
)((props: StyledTabProps) =>
  <Tab disableRipple
    onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      event.preventDefault();
    }} {...props} />);

function a11yProps(index: any) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
}

interface StyledTabProps {
  label: any;
  href?: string;
  value: string;
  labelvalue: string;
}